'use strict';

$(document).ready(function () {
    $('body').css('background', '#f8f8f8');
});
